
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-kits",
      function () {
        return require("private-next-pages/design-kits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-kits"])
      });
    }
  